import CircleIcon from '@mui/icons-material/Circle';
import { styled } from '@mui/material';

export const StyledStatusCircleIcon = styled(CircleIcon)(({ theme }) => ({
  color: theme.palette['green'].main,
  width: '1rem',
  height: '1rem',
}));
